"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactInfoFormSchema = void 0;
const Yup = require("yup");
exports.contactInfoFormSchema = Yup.object({
    email: Yup.string()
        .required('Email is a required field')
        .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'You must enter a valid email')
        .max(60, 'Email must be less than 60 characters'),
    phoneNumber: Yup.string()
        .required('Phone Number is a required field')
        .min(12, 'Invalid phone number')
        .max(12, 'Invalid phone number'),
});
